import React from 'react';
import { Alert, AlertTitle, List, ListItem, ListItemText, Box } from '@mui/material';
import responseErrorMapping from '../../utils/error.response.mapping';
const dummyErrorData = [
  { errorMessage: 'product_sku is required', param: 'required fields missing' },
  { errorMessage: 'product_name is required', param: 'required fields missing' },
  { errorMessage: 'serving_temperature is required', param: 'required fields missing' },
  { errorMessage: 'price is required', param: 'required fields missing' },
  { errorMessage: 'image_url is required', param: 'required fields missing' },
  { errorMessage: 'cuisine is required', param: 'required fields missing' },
  { errorMessage: 'product_type is required', param: 'required fields missing' },
  { errorMessage: 'available_quantity is required', param: 'required fields missing' },
  { errorMessage: 'product_category is required', param: 'required fields missing' },
  { errorMessage: 'special_marking is required', param: 'required fields missing' },
  { errorMessage: 'meal_type is required', param: 'required fields missing' },
  { errorMessage: 'serving_size is required', param: 'required fields missing' },
];

export default function ErrorFormAlert(props) {
  const { data } = props;

  return (
    <div style={{ width: '600px' }}>
      <Alert
        severity='error'
        sx={{
          backgroundColor: '#FFE6E1',
          border: '2px solid red',
          color: 'red',
          borderRadius: '3px',
        }}
      >
        <AlertTitle>Form Submission Errors</AlertTitle>

        <List sx={{ p: 0 }}>
          {data.map((err, index) => (
            <ListItem key={index} disableGutters sx={{ p: 0, m: 0 }}>
              <ListItemText
                sx={{ m: 0 }}
                primary={`• ${responseErrorMapping(err.errorMessage)}`}
                primaryTypographyProps={{
                  sx: {
                    color: 'red',
                    letterSpacing: '0.5px',
                    fontFamily: 'Inter Regular',
                    fontSize: '14px',
                    m: 0,
                  },
                }}
              />
            </ListItem>
          ))}
        </List>
      </Alert>
    </div>
  );
}
